/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { AbstractControl } from '@angular/forms';
import 'reflect-metadata';
import { FormFieldDecorator, FormModelDecorator } from './decorators';
import { ColumnType } from './definitions';
import { fieldDefinitions, formModelDefinitions } from './mapping';

export function formField(config?: FormFieldDecorator): Function {
  return function (target: Object, propertyName: string) {
    fieldDefinitions.push({
      targetConstructor: target.constructor,
      propertyName: propertyName,
      name: config?.name ? config.name : propertyName,
      type: ColumnType.FIELD,
      validators: config?.validators ? config.validators : null,
      updateOn: config?.updateOn ?? undefined,
      asyncValidator: config?.asyncValidator ? config.asyncValidator : null,
      propertyType: Reflect.getMetadata('design:type', target, propertyName),
    });
  };
}

export function subForm(config?: FormFieldDecorator): Function {
  return function (target: Object, propertyName: string) {
    fieldDefinitions.push({
      targetConstructor: target.constructor,
      propertyName: propertyName,
      name: config?.name ? config.name : propertyName,
      type: ColumnType.SUBFORM,
      validators: config?.validators ? config.validators : null,
      asyncValidator: config?.asyncValidator ? config.asyncValidator : null,
      propertyType: Reflect.getMetadata('design:type', target, propertyName),
    });
  };
}

export function formModel(config?: FormModelDecorator): Function {
  return function (target: Object) {
    formModelDefinitions.push({
      targetConstructor: target,
      converter: config?.converter ? config.converter : undefined,
      validators: config?.validator ? config.validator : null,
      asyncValidator: config?.asyncValidator ? config.asyncValidator : null,
      afterMapping: config?.afterMapping ? config.afterMapping : undefined,
    });
  };
}

export function formArray(config?: FormFieldDecorator): Function {
  return function (target: Object, propertyName: string) {
    fieldDefinitions.push({
      targetConstructor: target.constructor,
      propertyName: propertyName,
      name: config?.name ? config.name : propertyName,
      type: ColumnType.ARRAY,
      validators: config?.validators ? config.validators : null,
      asyncValidator: config?.asyncValidator ? config.asyncValidator : null,
      propertyType: Reflect.getMetadata('design:type', target, propertyName),
    });
  };
}

export interface FormConverterFn<T> {
  convert(input: T): AbstractControl;
}
